import { render, staticRenderFns } from "./one-million-trees-project.vue?vue&type=template&id=33581eb8&scoped=true"
import script from "./one-million-trees-project.vue?vue&type=script&lang=js"
export * from "./one-million-trees-project.vue?vue&type=script&lang=js"
import style0 from "./one-million-trees-project.vue?vue&type=style&index=0&id=33581eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33581eb8",
  null
  
)

export default component.exports